export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  DASHBOARD: '/app',
  OVERVIEW: '/app/overview',
  ONBOARDING: '/app/onboarding',
  RESTAURANT: '/app/restaurant',
  LOCATIONS: '/app/locations',
  LOCATIONS_NEW: '/app/locations/new',
  LOCATIONS_DETAIL: '/app/locations/:locationId',
  LOCATIONS_EDIT: '/app/locations/:locationId/edit',
  LOCATIONS_DELIVERY_ZONES: '/app/locations/:locationId/delivery-zones',
  CITIES: '/app/cities',
  PLATFORM: '/platform',
  PLATFORM_ORGANIZATIONS: '/platform/organizations',
  PLATFORM_ORGANIZATION_DETAIL: '/platform/organizations/:organizationId',
  PLATFORM_CITIES: '/platform/cities',
  PLATFORM_ADMINISTRATORS: '/platform/administrators',
  MENU: '/app/menu',
  MENU_DETAIL: '/app/menu/:menuId',
  PRODUCTS: '/app/products',
  ORDERS: '/app/orders',
  ORDERS_DETAIL: '/app/orders/:orderId',
  CUSTOMERS: '/app/customers',
  CUSTOMERS_DETAIL: '/app/customers/:customerKey',
  SETTINGS: '/app/settings',
  STOREFRONT_ORG: '/:citySlug/:orgSlug',
  STOREFRONT_LOCATION: '/:citySlug/:orgSlug/:locationSlug',
  STOREFRONT_LEGACY: '/s/:orgSlug',
  STOREFRONT_LEGACY_LOC: '/s/:orgSlug/:locationSlug',
  STOREFRONT_ORDER: '/s/:orgSlug/order/:publicToken',
} as const